import withErrorCheck from "../CheckError";
import server from "../Server";
import type { ICompetitionStandings } from "@grassrootly/api/entities";

export interface GetCompetitionStandingsPayload {
  seasonId: number;
}

// Fetch competition standings for a season using competition_season_standings_view
export const GetCompetitionStandings = async ({
  seasonId,
}: GetCompetitionStandingsPayload): Promise<ICompetitionStandings[]> => {
  const response = await server
    .from("competition_season_standings_view")
    .select("*")
    .eq("season_id", seasonId)
    .order("position", { ascending: true });

  const data = withErrorCheck<ICompetitionStandings[]>(response as any) || [];
  return data;
};
